import {
    CREATE_CUTTING_DC_FAILURE,
    CREATE_CUTTING_DC_REQUEST,
    CREATE_CUTTING_DC_SUCCESS,
    CREATE_USER_FORM_CUTTING_DC,
    FETCH_SINGLE_CUTTING_DC_FAILURE,
    FETCH_SINGLE_CUTTING_DC_REQUEST,
    FETCH_SINGLE_CUTTING_DC_SUCCESS,
    FETCH_CUTTING_DC_FAILURE,
    FETCH_CUTTING_DC_REQUEST,
    FETCH_CUTTING_DC_SUCCESS,
    NAVIGATE_CUTTING_DC_DETAILS,
    NAVIGATE_CUTTING_DC,
    CUTTING_DC_USERFORM_RESET,
    UPDATE_CUTTING_DC_FAILURE,
    UPDATE_CUTTING_DC_REQUEST,
    UPDATE_CUTTING_DC_SUCCESS,
    DELETE_CUTTING_DC_REQUEST,
    DELETE_CUTTING_DC_SUCCESS,
    DELETE_CUTTING_DC_FAILURE,
    CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_CUTTING_DC_INVOICE_REQUEST,
    FETCH_CUTTING_DC_INVOICE_SUCCESS,
    FETCH_CUTTING_DC_INVOICE_FAILURE,
    RESET_CUTTING_DC_INVOICE_V2,
    FETCH_CUTTING_DC_STYLE_REQUEST,
    FETCH_CUTTING_DC_STYLE_SUCCESS,
    FETCH_CUTTING_DC_STYLE_FAILURE,
    FETCH_CUTTING_DC_FORMAT_REQUEST,
    FETCH_CUTTING_DC_FORMAT_SUCCESS,
    FETCH_CUTTING_DC_FORMAT_FAILURE,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE,
    DELETE_CUTTING_DC_SUCCESS_CALL_OFF,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS_RESET,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_CUTTING_DC_PRINT
} from './cuttingDC.actionsType';

export const CUTTING_DC = 'cuttingDC';

let initialState = {
    loading: false,
    cuttingDC: [],
    cuttingDCInvoiceV2: [],
    cuttingDCStyle: [],
    cuttingDCFormat: [],
    cutQtywithSizePrint: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedCuttingDC: {},
    detailsId: '',
    activeKey: 1,
    isCuttingDC: false,
    cuttingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true
};

export let cuttingDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    if (type === 'CREATE_CUTTING_DC_SUCCESS') {
        localStorage.setItem('DetailStyleIdCut', JSON.stringify(updatePayload));

    }
    switch (type) {
        case FETCH_CUTTING_DC_REQUEST:
        case FETCH_CUTTING_DC_STYLE_REQUEST:
        case FETCH_CUTTING_DC_FORMAT_REQUEST:
        case FETCH_CUTTING_DC_INVOICE_REQUEST:
        case CREATE_CUTTING_DC_REQUEST:
        case FETCH_SINGLE_CUTTING_DC_REQUEST:
        case UPDATE_CUTTING_DC_REQUEST:
        case DELETE_CUTTING_DC_REQUEST:
        case FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDC: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case FETCH_CUTTING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCStyle: updatePayload?.PONO
            };
        case FETCH_CUTTING_DC_FORMAT_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCFormat: updatePayload
            };
        case FETCH_CUTTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCInvoiceV2: updatePayload
            };
        // case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD:
        //     return {
        //         ...state,
        //         cuttingDCInvoiceV2: payload
        //     }

        case FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                cutQtywithSizePrint: updatePayload?.CUD
            };
        case FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS_RESET:
        case FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE:
            return {
                ...state,
                loading: false,
                cutQtywithSizePrint: []
            };
        case CREATE_CUTTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_CUTTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCuttingDC: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case DELETE_CUTTING_DC_SUCCESS_CALL_OFF:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            }
        case UPDATE_CUTTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCuttingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_CUTTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedCuttingDC: {}
            };
        case FETCH_CUTTING_DC_FAILURE:
        case FETCH_CUTTING_DC_STYLE_FAILURE:
        case FETCH_CUTTING_DC_FORMAT_FAILURE:
        case FETCH_CUTTING_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_CUTTING_DC_FAILURE:
        case CREATE_CUTTING_DC_FAILURE:
        case UPDATE_CUTTING_DC_FAILURE:
        case DELETE_CUTTING_DC_FAILURE:
        case FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_CUTTING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CUTTING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                selectedCuttingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_CUTTING_DC_DETAILS:
            return {
                ...state,
                isCuttingDC: true,
                cuttingDCSelectedValue: updatePayload.cuttingDCSelectedValue
            };
        case NAVIGATE_CUTTING_DC:
            return {
                ...state,
                isCuttingDC: false
            };
        case RESET_CUTTING_DC_INVOICE_V2:
            return {
                ...state,
                cuttingDCInvoiceV2: []
            };
        case CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        case NAVIGATE_CUTTING_DC_PRINT:
            return {
                ...state,
                isCuttingDC: false,
                cuttingDCSelectedValue: updatePayload.cuttingDCSelectedValue
            };

        default:
            return state;
    }
};
